import { Chip, makeStyles } from '@material-ui/core'
import { blue, green, grey, orange } from '@material-ui/core/colors'
import { diaGuardado, paraDiaCivil } from './utils/vigencia'

export type Situacao = 'Ativo' | 'Futuro' | 'Encerrado' | 'Inativo'

export const situacaoColors: Record<Situacao, string> = {
  Ativo: green[300],
  Futuro: blue[200],
  Encerrado: orange[200],
  Inativo: grey[400]
}

interface CenarioSituacao {
  ativo: boolean
  dataInicio: string
  dataFim?: string | null
}

// Compara dias, não instantes: um cenário com fim em hoje ainda está Ativo o dia todo.
export function deriveSituacao(
  cenario: CenarioSituacao,
  hoje: Date = new Date()
): Situacao {
  if (!cenario.ativo) {
    return 'Inativo'
  }

  const diaHoje = paraDiaCivil(hoje)

  if (diaGuardado(cenario.dataInicio) > diaHoje) {
    return 'Futuro'
  }

  if (cenario.dataFim && diaGuardado(cenario.dataFim) < diaHoje) {
    return 'Encerrado'
  }

  return 'Ativo'
}

const useStyles = makeStyles(theme => ({
  customBadge: (props: { situacao: Situacao }) => ({
    backgroundColor: situacaoColors[props.situacao],
    width: 96,
    color: theme.palette.getContrastText(situacaoColors[props.situacao])
  })
}))

interface Props {
  cenario: CenarioSituacao
}

function SituacaoBadge({ cenario }: Props) {
  const situacao = deriveSituacao(cenario)
  const classes = useStyles({ situacao })

  return (
    <Chip
      label={situacao}
      size="small"
      variant="default"
      className={classes.customBadge}
    />
  )
}

export default SituacaoBadge
